export class ComparisonUrlParams {

  ids: string;

  path: string = '0';

  sessionid: number;

}